export const RefreshIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M1.5 9.58333C1.5 9.58333 3.71603 6.6239 5.51634 4.8581C7.31666 3.09229 9.8045 2 12.5526 2C18.0464 2 22.5 6.36522 22.5 11.75C22.5 17.1348 18.0464 21.5 12.5526 21.5C8.01763 21.5 4.19144 18.5255 2.99406 14.4583M1.5 9.58333V3.08333M1.5 9.58333H8.13158" />
    </svg>
  );
};
